import styled from 'styled-components';
export const StyledHeader = styled.header `
  display: flex;
  align-items: center;
  height: 8rem;
  padding: 0 8rem;
  box-shadow: 0 2px 20px rgba(1, 41, 112, 0.1);
`;
export const Title = styled.h1 `
  ${({ theme }) => theme.getFontStyle('samsung-800-24')};
  color: ${({ theme }) => theme.getColor('black', 'default')};
  display: flex;
  align-items: center;
  column-gap: 1.6rem;

  > span {
    margin-top: -0.2rem;
  }
`;
//# sourceMappingURL=Header.styles.js.map